import { Node } from 'slate';

export const BLANK_V2 = 'blank-v2';

export interface BlankV2Item {
  /** Required. Used to determined the `order` */
  parentNodeType: string;
}

export type BlankV2Node = Node &
  BlankV2Item & {
    id: string;
  };

export interface BlankV2Options {
  isReadOnly: boolean;
}
